<template>
  <component :is="tag" ref="root">
    <slot name="header" v-bind="{ isDropActive }" />
    <component 
      :is="borderTag" 
      ref="headerBorder"
      class="AwDropHeaderBorder hidden"
    />
    <transition-group
      :name="transitionName"
    >
      <template v-for="(item, index) in listWithPlaceholder">
        <slot v-bind="{ item, index, isDropActive, dropAreaId }" />
      </template>
    </transition-group>
    <component 
      :is="borderTag" 
      ref="footerBorder"
      class="AwDropFooterBorder hidden"
    />
    <slot name="footer" v-bind="{ isDropActive }" />
  </component>
</template>

<script>
import AwDnd from './AwDnd'
import { ref, watch, nextTick, computed, onMounted } from 'vue'

export default {
  emits: ['dropItem'],
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    transitionName: {
      type: String,
      default: 'document-elements'
    },
    listItemKey: {
      type: String,
      default: 'id'
    },
    dropAreaEl: {
      type: Object,
    },
    canDropItem: {
      type: Function,
      default: () => {
        return true
      }
    },
    dropDirection: {
      type: String,
      default: 'y'
    },
    createPlaceholder: {
      type: Function,
      default: null,
    },
    list: Array,
    dropAreaId: {
      type: String,
      default: null
    },
  },
  setup(props, { emit }) {
    const placeholderIndex = ref(null)
    const isDraggingOver = ref(false)
    const isDropActive = ref(false)
    const root = ref(null)
    const headerBorder = ref(null)
    const footerBorder = ref(null)
    
    const createPlaceholder = props.createPlaceholder
      ? props.createPlaceholder
      : (item) => {
      const placeholder = { ...item, placeholder: true }
      placeholder[props.listItemKey] = 'placeholder'
      return placeholder
    }
    
    const listWithPlaceholder = computed(() => {
      if (placeholderIndex.value === null) {
        return props.list
      }

      const arr = [...props.list]
      arr.splice(placeholderIndex.value, 0, createPlaceholder(AwDnd.draggedItem.value))
      return arr
    })
    
    const borderTag = computed(() => {
      if (props.tag === 'ul' || props.tag === 'ol') {
        return 'li'
      } else if (props.tag === 'table') {
        return 'tr'
      } else {
        return 'div'
      }
    })

    // function for getting elements which are not in header or footer
    const getDraggableElements = () => {
      const draggableElements = []

      for (let nextSibling = headerBorder.value.nextElementSibling; nextSibling && nextSibling !== footerBorder.value; nextSibling = nextSibling.nextElementSibling) {
        draggableElements.push(nextSibling)
      }

      return draggableElements
    }

    // insert placeholder to list
    watch(placeholderIndex, (val) => {
      if (val === null || val === undefined) {
        isDraggingOver.value = false
        root.value.classList.remove('AwDndOverElement')
        return
      }

      isDraggingOver.value = true
      nextTick(() => {
        const draggableElements = getDraggableElements()

        AwDnd.registerDropAreaPlaceholder(root.value, draggableElements[val])

        /*
        //if (!root.value.children[i].awDndObserved) {
          root.value.children[i].awDndObserved = true
          AwDnd.visibleElementsObserver.observe(root.value.children[i])
          AwDnd.visibleElements.set(root.value.children[i], {})
          AwDnd.invalidVisibleElementsData(false)
        //}
        */
      })
    })

    // item is dragged
    watch(AwDnd.draggedItem, (val) => {
      if (val === null) {
        isDropActive.value = false
        return
      }

      // check if element can be drop here
      if (!props.canDropItem(val)) {
        return
      }
      
      isDropActive.value = true

      nextTick(() => {
        // register self
        AwDnd.registerDropArea(root.value, getDraggableElements, placeholderIndex, props.dropDirection, props.dropAreaEl ? props.dropAreaEl : root.value, (item, index) => {
          emit('dropItem', { 
            item, 
            index, 
            overElement: AwDnd.overElement
          })
        })
      })
    }, { immediate: true })

    onMounted(() => {
      nextTick(() => {
        root.value.AwDndDropAreaId = props.dropAreaId
      })
    })

    return {
      listWithPlaceholder,
      placeholderIndex,
      isDraggingOver,
      isDropActive,
      root,
      headerBorder,
      footerBorder,
      borderTag
    }
  },
}
</script>